import { createSelector } from "reselect"
import { getPro } from "../Resources/Pro/ProData.js"
import DataEnrichmentApi from "./DataEnrichmentApi.js"
import { isBlank } from "utils/isBlank";
import { isPresent } from "utils/isPresent";

export const PRO_FROM_DATA_ENRICHMENT_NAMESPACE = 'proFromDataEnrichment';

export const getProFromDataEnrichment = createSelector(
    (state) => state.proFromDataEnrichment,
    (proFromDataEnrichment) => {
        return proFromDataEnrichment || {}
    }
)

export const getFirstName = createSelector(
    getPro,
    getProFromDataEnrichment,
    (pro, proFromDataEnrichment) => {
        return pro.first_name || proFromDataEnrichment.first_name || ""
    }
)

export const getLastName = createSelector(
    getPro,
    getProFromDataEnrichment,
    (pro, proFromDataEnrichment) => {
        return pro.last_name || proFromDataEnrichment.last_name || ""
    }
)

export const showDataAppendForFirstName = createSelector(
    getPro,
    getProFromDataEnrichment,
    (pro, proFromDataEnrichment) => {
        return (isBlank(pro.first_name) && isPresent(proFromDataEnrichment.first_name)) ? 'clearbitIcon' : null
    }
)

export const showDataAppendForLastName = createSelector(
    getPro,
    getProFromDataEnrichment,
    (pro, proFromDataEnrichment) => {
        return (isBlank(pro.last_name) && isPresent(proFromDataEnrichment.last_name)) ? 'clearbitIcon' : null
    }
)

export const fetchProFromDataEnrichment = {
    fetchingApiFunc: DataEnrichmentApi.fetchProFromDataEnrichment,
    selector: getProFromDataEnrichment,
    paramsFromProps: () => [],
    dataNamespace: PRO_FROM_DATA_ENRICHMENT_NAMESPACE
}
